import {
  ActiveView,
  ChangePasswordState,
  LoginState,
  PasswordPolicy
} from "@/modules/login/models/state";
import {LoginFields} from "@/modules/login/components/forms/login/login-models";
import {ChangePasswordFields} from "@/modules/login/components/forms/change-password/change-password-models";
import {Status} from "@/modules/login/models/api";
import {IError} from "@/models/models";

export interface LoginPageState {
  activeView: ActiveView;
  login: LoginState;
  changePassword: ChangePasswordState;
  status: Status;
  error: IError;
}

const state = {
  activeView: ActiveView.Login,
  login: {
    formFields: {
      userName: "",
      password: ""
    } as LoginFields
  } as LoginState,
  changePassword: {
    policy: {
      min_digits: 1,
      min_length: 8,
      min_nonletter: 1,
      min_special: 1,
      min_uppercase: 1
    } as PasswordPolicy,
    policyMap: new Map(),
    formFields: {
      old: "",
      current: "",
      confirm: ""
    } as ChangePasswordFields
  },
  status: Status.Idle,
  error: {
    message: "",
    timeout:10
  } as IError
} as LoginPageState;

export default state;
